import { usePublishingContext } from "../../contexts/PublishingContext.js";
import { getTHERMSImageSmallUrl } from "../../modules/Files/utils/get-therms-image-small-url.js";
import React from "react";
import { Image } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
//#region src/components/ImageSmall/index.tsx
var ImageSmall = React.memo(({ src, ...imageProps }) => {
	const publishingContext = usePublishingContext();
	const smallUrl = src ? getTHERMSImageSmallUrl(src) : void 0;
	return /* @__PURE__ */ jsx(Image, {
		src: smallUrl,
		lightbox: imageProps.lightbox && !publishingContext?.isPublishing,
		lightboxSrc: src,
		...imageProps
	});
});
//#endregion
export { ImageSmall };

//# sourceMappingURL=index.js.map